import sdk from '../../../../sdk';

export async function getCloudMembership() {
    try {
        const result = await sdk.resourceManager.getMembershipInfo();

        return Boolean(result?.isMemberOfCloud);
    } catch {
        return false;
    }
}
